export default __webpack_public_path__ + "static/media/card_loading.ffb57b60.png";